
import CurrencyFormat from "react-currency-format";

/* Routing */
import { Link } from "react-router-dom";

/* Icons */
import DeleteIcon from "@material-ui/icons/Delete";
import imageBroken from "assets/img/image.svg";

/* Material-UI */
import TextField from "@mui/material/TextField";

import { Box } from "@material-ui/core";
import DiscountLogo from "components/DiscountLogo/DiscountLogo";
import { deleteItem, updateAmount } from 'helpers/ShoppingCartFunctions';
import { useEffect, useState } from "react";

const container = {
  padding: '15px',
};

export default function Products({ items }) {

  const [cartItems, setCartItems] = useState([]);
  useEffect(() => {
    setCartItems(items);
  }, [items])

  const handleUpdateAmount = (id, category, variant, newAmount) => {
    if (isNaN(newAmount) || Number(newAmount) < 0 || Number(newAmount) > 100 || !Number.isInteger(Number(newAmount))) {
      return;
    }

    setCartItems(prevItems => {
      return prevItems.map(item =>
        item.id === id && item.category === category && item.variant === variant
          ? { ...item, amount: newAmount }
          : item
      );
    });
    updateAmount(id, category, variant, newAmount);
  };

  const handleDeleteItem = (id, category, variant) => {
    setCartItems(prevItems => {
      return prevItems.filter(item =>
        !(item.id === id && item.category === category && item.variant === variant)
      );
    });

    deleteItem(id, category, variant);
  }

  return (
    <div style={container}>
      {cartItems !== null && cartItems.map((item, idx) => (
        <ProductItem
          id={item.id}
          title={item.title}
          url={item.url}
          type={item.category}
          description={item.description}
          price={item.price}
          discount={item.discount}
          discountPrice={item.discountPrice}
          amount={item.amount}
          discountPercentage={item.discountPercentage}
          variant={item.variant}
          onAmountChange={handleUpdateAmount}
          handleDeleteItem={handleDeleteItem}
        />
      ))}
    </div>
  );
}

function ProductItem({
  id,
  title,
  url,
  type,
  description,
  price,
  discount,
  discountPrice,
  amount,
  discountPercentage,
  variant,
  onAmountChange,
  handleDeleteItem }) {

  const card = {
    padding: "15px",
    backgroundColor: "white",
    fontSize: "20px",
    fontWeight: "300",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  };

  const imgStyle = {
    cursor: "pointer",
    width: "150px",
    height: "150px",
    marginRight: "10px",
  };

  const titleStyle = {
    fontWeight: "300",
    fontSize: "18px",
    marginBottom: "5px",
    fontFamily: "Poppins, sans-serif",
  };

  const productContainer = {
    alignItems: "center",
    margin: "5px",
  };

  const quantity = {
    backgroundColor: "white",
    marginLeft: "10px",
    width: "60px",
  };

  const verticalLine = {
    width: "1px",
    height: "30px",
    marginLeft: "10px",
    marginRight: "10px",
    backgroundColor: "black",
  };

  return (
    <div style={card}>
      {url === null && (
        <Link to={`/Producto?product=${type}&id=${id}`} target="_blank">
          <img src={imageBroken} alt="car" style={imgStyle} />
        </Link>
      )}
      {url !== null && (
        <Link to={`/Producto?product=${type}&id=${id}`} target="_blank">
          <img src={url} alt="car" style={imgStyle} />
        </Link>
      )}
      <div style={container}>
        <div style={{ display: "flex", ...productContainer }}>
          <Box style={titleStyle}>
            {" "}
            {title} {description ? `(${description})` : ""}
          </Box>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "15px",
              alignSelf: "flex-start",
            }}
          >
            <DeleteIcon
              style={{ cursor: "pointer" }}
              onClick={() => { handleDeleteItem(id, type, variant); }}
            />
            <div style={verticalLine} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{ fontFamily: "Poppins, sans-serif", fontWeight: "400" }}
              >
                Cantidad:{" "}
              </div>
              <TextField
                inputProps={{
                  min: 0,
                  style: { textAlign: "center", height: "15px" },
                }}
                size="small"
                style={quantity}
                value={amount}
                onChange={(e) => onAmountChange(id, type, variant, e.target.value)}
                onBlur={(e) => {
                  if (isNaN(e.target.value) || e.target.value < 1)
                    onAmountChange(id, type, variant, 1)
                }}
              />
            </div>
          </div>
        </div>
        <DiscountLogo
          width="150px"
          fontSize="14px"
          discount={discountPercentage}
        />
        <Box
          style={{
            fontSize: "17px",
            fontWeight: "500",
            fontFamily: "Poppins, sans-serif",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ fontWeight: "700" }}>
            {" "}
            Precio Unit:{" "}
            <CurrencyFormat
              value={price}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType={"text"}
              prefix="$"
              style={{
                textDecoration: discount ? "line-through" : "none",
                color: discount ? "gray" : "inherit",
                fontWeight: "300",
                fontFamily: "Nunito Sans, sans-serif",
              }}
            />{" "}
            <CurrencyFormat
              value={discountPrice}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType={"text"}
              prefix="$"
              style={{
                color: "#E21608",
                fontWeight: "600",
                fontFamily: "Nunito Sans, sans-serif",
              }}
            />{" "}
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                fontWeight: "900",
                fontFamily: "Nunito Sans, sans-serif",
                marginRight: "5px",
              }}
            >
              Precio:
            </div>
            <CurrencyFormat
              value={amount * (discount ? discountPrice : price)}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
              displayType={"text"}
              prefix="$"
              style={{
                fontWeight: "300",
                fontFamily: "Nunito Sans, sans-serif",
              }}
            />
          </div>
        </Box>
      </div>
    </div>
  );
}